import { useQuery } from "react-query";
import { getOnePrize } from "services/prize";

export default function usePrize(id) {
  return useQuery(["prizes", id], async () => await getOnePrize(id));
}
